export default __webpack_public_path__ + "static/amazon-eee97d236465a461841d689ed0883512.png";